import {
  getUserAnalyticsObject,
  isShowAnalyticsEventLoaded,
  sanitizeTextForAnalytics,
} from "@/utils/helper"
export const analyticsCB = (status, cartObj = "") => {
  const page = window.pageObj || {}
  if (status !== "success" && page.eventInfo) {
    page.eventInfo.eventStatus = "failure"
    page.eventInfo.eventMsg = status || "failed to update item(s) in cart."
    const otherItems = {}
    if (page.updatedSku) {
      // get productInfo and add to event page objet.
      const matchingSku = page.cart?.item?.find(
        prod =>
          prod.productInfo?.productID?.toLowerCase() ===
          page.updatedSku.toLowerCase()
      )
      if (matchingSku) {
        otherItems.productInfo = matchingSku.productInfo
      }
    }
    otherItems.eventInfo = page.eventInfo
    delete page.eventInfo
    window.adobeDataLayer.push({
      event: "cmp:click",
      page,
      ...otherItems,
    })
  } else if (page.eventInfo && cartObj) {
    calculateCartAnalytics({ cart: cartObj, eventName: "cmp:click" })
  }
}

export const calculateCartAnalytics = ({ cart, eventName = "cmp:show" }) => {
  const page = window.pageObj || {}
  page.cart = cart
  page.user = getUserAnalyticsObject()
  if (
    eventName === "cmp:show" &&
    page.user &&
    (!page.user.gId || page.user.gId === "n/a") &&
    (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")
  ) {
    window.pageObj = page
    window.isShowAnalyticsEvent = true
  } else if (
    (eventName === "cmp:show" && !isShowAnalyticsEventLoaded()) ||
    eventName !== "cmp:show"
  ) {
    let otherItems = {}
    if (eventName !== "cmp:show") {
      if (page.eventInfo) {
        otherItems = { eventInfo: page.eventInfo }
        delete page.eventInfo
      }
      const matchedItem = cart?.item?.find(
        prod => prod.productInfo?.productUpdated === true
      )
      if (matchedItem) {
        // here check initialQuantity from oldCart object.

        if (window.oldValue) {
          matchedItem.productInfo.initialQuantity = window.oldValue
          delete window.oldValue
        }
        otherItems.productInfo = matchedItem.productInfo
      }
    }
    window.adobeDataLayer.push({
      event: eventName,
      page,
      ...otherItems,
    })
  }
}

export const addCartItemSummaryAnalytics = (
  page,
  prodDesc,
  prodName,
  pdpNavigationURL,
  itemName = ""
) => {
  return JSON.stringify({
    clickInternalLinks: "true",
    eventAction: `${
      page !== "cart" && page !== "checkout"
        ? "my account:orders:order details"
        : page === "cart"
        ? "cart preview"
        : page
    }:product navigation`,
    eventMsg: "n/a",
    eventName: `${
      page !== "cart" && page !== "checkout"
        ? "my account:orders:order details"
        : page === "cart"
        ? "cart preview"
        : page
    }:product navigation`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: itemName, // populate with the actual link name
    internalLinkPosition:
      page !== "cart" && page !== "checkout" ? "my order" : page,
    internalLinkType: `${
      page !== "cart" && page !== "checkout" ? "my account" : page
    }:navigation`,
    internalLinkURL: pdpNavigationURL
      ? (pdpNavigationURL?.indexOf("http") === -1
          ? window.location.origin
          : "") + pdpNavigationURL
      : "n/a",
    internalLinkZoneName:
      page !== "cart" && page !== "checkout"
        ? "my account:orders:order details"
        : page + ":preview",
  })
}

export const addRemoveProductFromCartAnalytics = (action, data) => {
  const eventInfo = {
    eventAction: "cart:landing page:remove",
    eventName: "cart:landing page:remove",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "remove",
    internalLinkPosition: "cart",
    internalLinkType: "cart:navigation",
    internalLinkZoneName: "cart:landing page:cart items",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }

  sessionStorage.setItem("cartLanding", eventInfo.searchCount)
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}

  const removedItem = page?.cart?.item?.find(
    item => item.productInfo.productID === data.sku
  )
  const updatedPage = page?.cart?.item?.filter(
    item => item?.productInfo?.productID !== data.sku
  )

  if (page && page.cart && page.cart.item) {
    page.cart.item = updatedPage
  }

  window.adobeDataLayer.push({
    event: action,
    page,
    eventInfo,
    productInfo: removedItem?.productInfo,
  })
}
